const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://junioralarm.mbsoftwaresolutions.de/0_Server';

/**
 * Allgemeine POST-Request-Funktion
 */
const postRequest = async (endpoint: string, body: any) => {
  try {
    const response = await fetch(`${BASE_URL}/${endpoint}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData?.message || 'Server Fehler');
    }

    return response.json();
  } catch (error) {
    console.error('API Fehler:', error);
    throw error;
  }
};

// Auth
export const loginRequest = (username: string, password: string) =>
  postRequest("LoginHandler.php", { username, password });

// Paper Account
export const changePaperAccount = (tag: string) =>
  postRequest("ChangePaperAccount.php", { tag });

// Push
export const sendPushRequest = (payload: any) =>
  postRequest("SendPushNotification.php", payload);

export const sendPushOneSignalRequest = (payload: any) =>
  postRequest("SendPushNotificationOneSignal.php", payload);

// TestAlarms
export const updateTestAlarmsRequest = (tag: string, testAlarms: number) =>
  postRequest("UpdateTestAlarms.php", { tag, testAlarms });

// ChangePassword
export const changePasswordRequest = (tag: string, password: string) =>
  postRequest("ChangePassword.php", { tag, password }).then(
    (res) => res.message === "Update erfolgreich"
  );

// CheckPassword
export const checkPasswordRequest = (tag: string, password: string) =>
  postRequest("PasswordChecker.php", { tag, password }).then(
    (res) => res.message === "OK"
  );

  // Account / Settings
export const getAccountStatusRequest = (tag: string) =>
  postRequest("GetAccountStatus.php", { tag });

//Units Settings
// Units
export const readUnitsRequest = (loginID: string) =>
  postRequest("ReadUnits.php", {
    transferCheckSum: "xz5h4z3o",
    loginID,
  });

export const updateUnitRequest = (unitID: string, column: string, value: string) =>
  postRequest("UpdateUnit.php", {
    unitID,
    column,
    value,
  });

export const deleteUnitRequest = (id: number) =>
  postRequest("DeleteUnit.php", {
    ID: id,
  });

export const addUnitRequest = (loginID: string) =>
  postRequest("AddUnit.php", {
    loginID,
  });

// Send New Password
export const sendNewPasswordRequest = (mail: string) =>
  postRequest("SendNewPassword.php", { mail });

// Change Account State
export const changeAccountStateRequest = (tag: string) =>
  postRequest("ChangeAccountState.php", { tag });

// Registration / SignIn
export const addNewSignInRequest = (place: string, password: string, mail: string) =>
  postRequest("AddNewSignIn.php", { place, password, mail });

export const signInCheckerRequest = (columnName: string, columnValue: string) =>
  postRequest("SignInChecker.php", { columnName, columnValue });

//Delete User
export const DeleteUserRequest = (loggedID: string) =>
  postRequest("DeleteUser.php", { loggedID });